/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReplyItemResVo
 */
export interface ReplyItemResVo {
    /**
     * 回复真实主键。
     * @type {number}
     * @memberof ReplyItemResVo
     */
    id?: number;
    /**
     * 回复员工真实主键。
     * @type {number}
     * @memberof ReplyItemResVo
     */
    staffId?: number;
    /**
     * 回复员工姓名；员工注销后为空。
     * @type {string}
     * @memberof ReplyItemResVo
     */
    staffName?: string;
    /**
     * 回复正文。
     * @type {string}
     * @memberof ReplyItemResVo
     */
    content?: string;
    /**
     * 回复时间。
     * @type {string}
     * @memberof ReplyItemResVo
     */
    createTime?: string;
}

/**
 * Check if a given object implements the ReplyItemResVo interface.
 */
export function instanceOfReplyItemResVo(value: object): value is ReplyItemResVo {
    return true;
}

export function ReplyItemResVoFromJSON(json: any): ReplyItemResVo {
    return ReplyItemResVoFromJSONTyped(json, false);
}

export function ReplyItemResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplyItemResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'staffId': json['staffId'] == null ? undefined : json['staffId'],
        'staffName': json['staffName'] == null ? undefined : json['staffName'],
        'content': json['content'] == null ? undefined : json['content'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
    };
}

export function ReplyItemResVoToJSON(json: any): ReplyItemResVo {
    return ReplyItemResVoToJSONTyped(json, false);
}

export function ReplyItemResVoToJSONTyped(value?: ReplyItemResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'staffId': value['staffId'],
        'staffName': value['staffName'],
        'content': value['content'],
        'createTime': value['createTime'],
    };
}

